import { Draft } from '@reduxjs/toolkit';

import { IUserData } from '../../index';

function changeStatusFailure(draft: Draft<IUserData>) {
  draft.changeStatus.config.isLoading = false;
}

export default changeStatusFailure;
